import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Chart, registerables } from "chart.js";
import { DashboardService } from "../services/dashboard.service";
import { SessionService } from "../services/active-session-management.service";
import { CommonModule } from "@angular/common";

Chart.register(...registerables);

@Component({
  selector: "app-credit-score-history",
  templateUrl: "./credit-score-history.component.html",
  styleUrls: ["./credit-score-history.component.css"],
  standalone: true,
  imports: [CommonModule],
})
export class CreditScoreHistoryComponent implements OnInit, OnDestroy {
  @Input() item = "";
  enableGraph = true;
  monthList: any;
  scoreList: any;
  scoreGraphData;
  progressIndicator: number;
  text;
  progressData;
  cssClass;
  display = false;
  hasData = false;
  activeSession = true;
  registrationDate;
  chartInstance: Chart | null = null;

  constructor(
    private dashboardService: DashboardService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    if (!localStorage.getItem("flag")) {
      localStorage.setItem("flag", "true");
      this.sessionService.setActiveSession();
      this.activeSession = true;
    }

    this.sessionService.checkActiveSession();
    setTimeout(() => {
      this.getHistoricCreditScoreByIdnumber();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroyChart();
  }

  private destroyChart() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  }

  private graphIntegration(
    scoreList,
    monthList,
    canvasElement: HTMLCanvasElement
  ) {
    this.destroyChart();

    const ctx = canvasElement.getContext("2d");
    if (!ctx) return;

    const gradient = ctx.createLinearGradient(0, 0, 0, 200);
    gradient.addColorStop(0, "rgba(74, 174, 172, 0.49)");
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

    const data = {
      labels: monthList,
      datasets: [
        {
          label: "Credit Score",
          data: scoreList,
          backgroundColor: gradient,
          borderColor: "rgba(74, 174, 172, 1)",
          pointBackgroundColor: "rgba(74, 174, 172, 1)",
          fill: true,
          tension: 0,
          pointRadius: 5,
        },
      ],
    };

    const options: any = {
      responsive: true,
      maintainAspectRatio: false,
      clip: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.formattedValue;
            },
            title: function (context) {
              return context[0].label;
            },
          },
          backgroundColor: "#fff",
          titleFont: { size: 14, weight: "normal" },
          titleAlign: "center",
          titleColor: "rgba(74, 174, 172, 1)",
          bodyFont: {
            size: 14,
            weight: "normal",
          },
          bodyColor: "rgba(74, 174, 172, 1)",
          displayColors: false,
          borderColor: "rgba(74, 174, 172, 1)",
          borderWidth: 2,
          padding: 10,
        },
      },
      scales: {
        x: {
          ticks: {
            color: "#2B373F",
            font: {
              size: 14,
              style: "normal",
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          min: 0,
          max: 1000,
          ticks: {
            padding: 10,
            stepSize: 200,
            color: "#2B373F",
            font: {
              size: 14,
              style: "normal",
            },
            callback: function (value) {
              return value.toString();
            },
          },
          grid: {
            color: "rgba(231, 231, 231, 1)",
          },
        },
      },
    };

    this.chartInstance = new Chart(ctx, {
      type: "line",
      data: data,
      options: options,
    });
  }

  getHistoricCreditScoreByIdnumber() {
    const elementName = this.item;
    const scoreData = sessionStorage.getItem("creditScore");

    if (scoreData != null) {
      this.BindCreditScore(JSON.parse(scoreData), elementName);
      return;
    }

    if (this.activeSession) {
      this.dashboardService.getCreditScoreChart().subscribe({
        next: (data: any) => {
        this.BindCreditScore(data, elementName);
        sessionStorage.setItem("creditScore", JSON.stringify(data));
      }});
    }
  }

  private BindCreditScore(data: any, elementName: string) {
    if (data.creditScoreResponse.length === 0) {
      this.hasData = false;
      this.registrationDate = data.registrationDate;
      return;
    }

    this.hasData = true;
    this.removeDuplicateObject(data.creditScoreResponse, (result) => {
      this.scoreGraphData = result;

      if (this.scoreGraphData.length === 0) {
        this.enableGraph = false;
      } else {
        const canvas = document.getElementById(
          elementName
        ) as HTMLCanvasElement;
        if (!canvas) return;

        this.monthList = this.scoreGraphData
          .map((a) => `${a.month} ${a.year.toString().substr(2, 2)}`)
          .reverse();
        this.scoreList = this.scoreGraphData.map((a) => a.score).reverse();
        const scoreLen = this.scoreList.length;
        this.progressIndicatcor(
          this.scoreList[scoreLen - 1],
          this.scoreList[scoreLen - 2]
        );
        this.graphIntegration(this.scoreList, this.monthList, canvas);
      }
    });
  }

  removeDuplicateObject(data, callback) {
    const result = [];
    data.forEach((e) => {
      const found = result.some(
        (item) => item.year === e.year && item.month === e.month
      );
      if (!found) result.push(e);
    });
    callback(result);
  }

  progressIndicatcor(latestScore: number, secondLatest: number) {
    const diff = latestScore - secondLatest;
    this.progressIndicator = Math.abs(diff);

    if (diff > 0) {
      this.text = "improved since last month";
      this.cssClass = "progreesIndicator-up";
    } else if (diff === 0) {
      this.text = "since last month";
    } else {
      this.text = "decreased since last month";
      this.cssClass = "progreesIndicator-down";
    }

    this.progressData = {
      realValue: this.progressIndicator,
      text: this.text,
      cssClass: this.cssClass,
    };
    this.display = true;
  }
}
